import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  uploadFileURL,
} from '../../axios/requests';
import {
  createRestaurantCategory, getRestaurantCategories, getRestaurantCategoryById, updateRestaurantCategory, updateRestaurantCategoryStatus,
} from '../../axios/restaurantCategoriesRequests';
import {
  convertCountriesToISOCodeString,
} from '../../constants/countries';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  uploadFile,
} from '../../helperFunctions/uploadService';
import {
  ICountry,
} from '../storeInterfaces/authInterface';
import {
  IRestaurantCategoryStore,
} from '../storeInterfaces/restaurantCategoryInterface';
import { RequestStatus } from 'mobx-store';

export class RestaurantCategoryStore implements IRestaurantCategoryStore {
  @observable categoriesList: any[] = [];

  @observable selectedCategory = {
  };

  @observable loading = false;

  @observable getRestaurantCategoriesRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getCategories(restaurantId: number, countries: ICountry[], langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.loading = true;
      this.getRestaurantCategoriesRequestStatus = RequestStatus.LOADING;
      const availableCountries = convertCountriesToISOCodeString(countries);

      const params = {
        availableCountries,
        status: 'all',
      };

      const response = await Connections.wadiDeglaAxios.httpGet(getRestaurantCategories(restaurantId), {
        ...getHeader(langCode), params,
      });
      this.categoriesList = this.restructureCategoriesList(response.data);
      this.getRestaurantCategoriesRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getRestaurantCategoriesRequestStatus = RequestStatus.FAILED;
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async getCategoryById(id: number, langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getRestaurantCategoryById(id), getHeader(langCode));
      this.selectedCategory = this.restructureCategory(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async createCategory(restaurantId: number, newCategory: any, langCode: string = DefaultLanguage): Promise<any> {
    return new Promise<void>(async (res, rej) => {
      try {
        newCategory.image = await this.uploadSingleImage(newCategory.image);
        const response = await Connections.wadiDeglaAxios.httpPost(createRestaurantCategory(restaurantId),
          this.restructureUpdatedOrCreatedCategory(newCategory),
          getHeader(langCode));
        res(response);
      } catch (error) {
        rej(error);
      }
    });
  }

  @action.bound
  public async updateCategory(updatedCategory: any, id: number, langCode: string = DefaultLanguage): Promise<any> {
    try {
      updatedCategory.image = await this.uploadSingleImage(updatedCategory.image);
      await Connections.wadiDeglaAxios.httpPut(updateRestaurantCategory(id), this.restructureUpdatedOrCreatedCategory(updatedCategory), getHeader(langCode));
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound
  public async updateCategoryStatus(updatedCategoryStatus: boolean, index: number): Promise<any> {
    try {
      await Connections.wadiDeglaAxios.httpPut(updateRestaurantCategoryStatus(this.categoriesList[index].categoryId),
        {
          isActive: updatedCategoryStatus,
        });
    } catch (error) {
      console.log(error);
    } finally {
      this.categoriesList[index].isActive = updatedCategoryStatus;
    }
  }

  private restructureCategoriesList(categories: any[]): any[] {
    const categoriesList = [];
    for (const restaurant of categories) {
      categoriesList.push({
        categoryId: restaurant.restaurantCategoryId,
        title: restaurant.name,
        isActive: restaurant.isActive,
      });
    }
    return categoriesList;
  }

  private restructureCategory(category: any): any {
    return {
      categoryId: category.restaurantCategoryId,
      image: (category.imageURL ? [{
        imageUrl: category.imageURL,
      }] : []),
      title: category.name,
    };
  }

  private uploadSingleImage(images: any[]) {
    const promises = [];
    const allImages: any[] = [];
    for (const image of images) {
      if (image.preview) {
        promises.push(
          uploadFile(uploadFileURL, image)
            .then((res: any) => {
              allImages.push(res.data.downloadURL);
            }),
        );
      } else {
        allImages.push(image.imageUrl);
      }
    }
    return Promise.all(promises)
      .then(() => {
        console.log('done');
        return (allImages.length ? allImages[0] : null);
      }).catch((error) => {
        console.log('error');
        return (allImages.length ? allImages[0] : null);
      });
  }

  private restructureUpdatedOrCreatedCategory(category: any): any {
    return {
      name: category.title,
      imageURL: category.image,
      availableCountries: category.availableCountries,
    };
  }
}
